
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    import { Adjunto } from '@/__env/lib/MercadoLibre/Chats/Mensajes/Mensaje.lib';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        @Prop() public CorrerMas: boolean;
        @Prop() public Correr: boolean;

        public get NuevoMensaje() { return this.Controlador.NuevoMensaje; };
        public get Archivos() { return this.NuevoMensaje.Archivos; };
        public get EnviandoMensaje() { return this.NuevoMensaje.EnviandoMensaje; };

        public Ocultar: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }


        mounted()
        {

        }

        EliminarArchivo( item: Adjunto )
        {
            this.NuevoMensaje.EliminarArchivo( item );
        }
    }
